import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";
import { Helmet } from "react-helmet-async";

const faqs = [
  {
    question: "What types of businesses do you work with?",
    answer:
      "Australian trade and local-service businesses — including plumbers, electricians, HVAC, pest control, roofers, tree services, rubbish removal, removalists, garage doors, emergency glass, cleaning services and builders.",
  },
  {
    question: "Do I need every service?",
    answer:
      "No. We look at what is limiting results right now and recommend the smallest sensible starting point. You can add more later if it makes sense.",
  },
  {
    question: "How much does it cost?",
    answer:
      "It depends on what your business needs. After a short review of your website, Google presence and lead handling, we give you a clear quote with the scope and costs written down.",
  },
  {
    question: "How quickly can we get started?",
    answer:
      "Usually within a couple of weeks of the initial call, once we have agreed on the scope and have access to the accounts we need.",
  },
  {
    question: "How long does local visibility improvement take?",
    answer:
      "Local visibility is a gradual process, and improvements usually build over several months rather than appearing straight away. We cannot promise specific rankings or lead volumes.",
  },
  {
    question: "Do I need to sign a long-term contract?",
    answer:
      "We work on monthly plans. Project work such as a website build has its own agreed scope and timeline, which we explain before starting.",
  },
];

export function FAQSection() {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: { "@type": "Answer", text: faq.answer },
    })),
  };

  return (
    <section
      id="faq-section"
      className="section-padding bg-muted relative overflow-hidden"
      aria-labelledby="faq-heading"
    >
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>
      <div className="absolute inset-0 grid-pattern opacity-40" />

      <div className="container-wide relative z-10">
        <Reveal className="max-w-3xl mx-auto text-center mb-10 sm:mb-12">
          <span className="section-badge mb-4">Frequently Asked Questions</span>
          <h2
            id="faq-heading"
            className="heading-section text-foreground mt-4 text-balance"
          >
            Questions worth asking before you{" "}
            <span className="heading-accent">get started</span>
          </h2>
        </Reveal>

        <Reveal delay={0.08} className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="rounded-2xl border border-border/60 bg-card shadow-card px-5 sm:px-6 data-[state=open]:border-primary/25"
              >
                <AccordionTrigger className="text-left text-base sm:text-lg font-semibold text-foreground hover:no-underline py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-5 leading-[1.7] text-base">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
